import ApiService from './ApiService';

class CourseApi extends ApiService {
    constructor() {
        super('course');
    }

    getCoursesByName(payload = {}) {
        return this.get('', payload);
    }

    // #18006: the course list is split per authentication state. This public endpoint returns the
    // reduced guest field set even if a token is sent, so logged-in screens must use the internal one.
    getAllCourses(payload) {
        return this.get('all', payload);
    }

    getAllCoursesInternal(payload) {
        return this.get('all/internal', payload);
    }

    getCourseById(payload) {
        return this.get(payload?.id, payload);
    }

    getCourseInternalById(payload) {
        return this.get(`${payload?.id}/internal`, payload);
    }

    getListCompletionTest(payload) {
        return this.get(`${payload?.courseId}/list-completion-tests`, { random: true, isStudent: true });
    }

    submitCompletionTest({ courseId, payload }) {
        return this.post(`${courseId}/completion-test`, payload);
    }

    getTestResultHistory(courseId) {
        let newApi = new ApiService(null, null)
        return newApi.get(`test-result-history/${courseId}`, {})
    }

    getLectureListByCourse(payload) {
        return this.get(`${payload?.id}/lecture`, payload);
    }

    getLectureListByCourseInternal(payload) {
        return this.get(`${payload?.id}/lecture/internal`, payload);
    }

    getCourseChart(courseId) {
        return this.get(`${courseId}/chart`);
    }

    studentBuyCourse(courseId) {
        return this.post('addition', { courseId: courseId });
    }

    getAttendingCourseForCancel() {
        let newApi = new ApiService(null, null);
        return newApi.get('attending-course-for-cancel');
    }

    getAttendanceHistories(payload = {}) {
        return this.post('attendance/history', payload);
    }

    getAttendanceHistoriesEI(payload = {}) {
        return this.get('attendance/history/ee-to-ei', payload);
    }

    getListCoursePeriod(payload = {}) {
        return this.get('attendance/list-course-period', payload);
    }

    exportAttendanceHistories(payload = {}) {
        return this.post('attendance/export-pdf', payload, undefined, 'blod');
    }

    getCourseSurvey(payload) {
        return this.get(`${payload?.courseId}/survey`);
    }

    sendCourseSurvey({ courseId, payload }) {
        return this.post(`${courseId}/survey`, payload);
    }

    getTrainingCourseList(payload) {
        let newApi = new ApiService(null, null);
        return newApi.get('training-courses', payload);
    }

    submitTrainingCourseReport({ id, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.put(`submit-report/${id}`, payload);
    }

    submitTrainingCourseQuestion({ id, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.put(`submit-question/${id}`, payload);
    }

    getTrainingCourseListForGA(payload) {
        let newApi = new ApiService(null, null);
        return newApi.get('training-courses-company', payload);
    }

    getTrainingCourseDetailForGA({ id, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.get(`training-courses-company/${id}`, payload);
    }

    updateSettingsTrainingCourseForGA({ id, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.put(`training-courses-company/settings/${id}`, payload);
    }

    downloadReportTrainingCourse({ id, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.post(`training-courses-company/download/${id}`, payload, null, 'blob');
    }

    getTicketPlanListForGA(payload) {
        let newApi = new ApiService(null, null);
        return newApi.get('training-ticket-plans-company', payload);
    }

    getCompletionSettingsForGA({ ticketId }) {
        let newApi = new ApiService(null, null);
        return newApi.get(`training-ticket-plans-company/${ticketId}/completion-settings`);
    }

    getEligibleStudentsForCertificate({ ticketId, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.get(`training-ticket-plans-company/${ticketId}/eligible-students`, payload);
    }

    updateCompletionSettingsForGA({ ticketId, payload }) {
        let newApi = new ApiService(null, null);
        return newApi.put(`training-ticket-plans-company/${ticketId}/completion-settings`, payload);
    }

    issueCompletionCertificate(ticketId) {
        let newApi = new ApiService(null, null);
        return newApi.get(`training-courses/certificate/${ticketId}`, {}, null, 'blob');
    }
}

export default CourseApi;